<template>
    <div class="nevs-content">
        <ModalIncomingInvoice @done="modalDone" :show="modal.show" :incomingInvoiceId="modal.incomingInvoiceId"></ModalIncomingInvoice>
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
            <NevsTableFilters ref="filterPanel" :summary="filterSummary" @clear="clearFilter"
                              @toggle="filtersToggled">
                <NevsTextField v-model="tableData.filters.number" :label="$LANG.Get('fields.number')"></NevsTextField>
                <NevsTextField v-model="tableData.filters.supplier_name" :label="$LANG.Get('fields.supplierName')"></NevsTextField>
                <NevsTextField v-model="tableData.filters.supplier_vat_id" :label="$LANG.Get('fields.supplierVatId')"></NevsTextField>
                <NevsTextField v-model="tableData.filters.short_description" :label="$LANG.Get('fields.shortDescription')"></NevsTextField>
                <NevsDateField v-model="tableData.filters.date_of_issue_from"
                               :label="$LANG.Get('fields.date_of_issue_from')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.date_of_issue_to"
                               :label="$LANG.Get('fields.date_of_issue_to')"></NevsDateField>
            </NevsTableFilters>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.number }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.date_of_issue_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.supplier_name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.supplier_vat_id }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.short_description }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.amount_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.currency }}</td>
                    <td class="nevs-table-actions">
                        <NevsActions :width="'200px'" :actions="tableActions" :context="item"></NevsActions>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsTableFilters from "@/components/nevs/NevsTableFilters.vue";
import NevsActions from "@/components/nevs/NevsActions.vue";
import ModalIncomingInvoice from "@/components/modals/ModalIncomingInvoice.vue";

export default {
    name: "ModuleIncomingInvoices",
    components: {NevsTableFilters, ModalIncomingInvoice, NevsActions, NevsDateField, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'number',
                        label: this.$LANG.Get('fields.number')
                    },
                    {
                        name: 'date_of_issue',
                        label: this.$LANG.Get('fields.dateOfIssue')
                    },
                    {
                        name: 'supplier_name',
                        label: this.$LANG.Get('fields.supplierName')
                    },
                    {
                        name: 'supplier_vat_id',
                        label: this.$LANG.Get('fields.supplierVatId')
                    },
                    {
                        name: 'short_description',
                        label: this.$LANG.Get('fields.shortDescription')
                    },
                    {
                        name: 'amount',
                        label: this.$LANG.Get('labels.amount')
                    },
                    {
                        name: 'currency',
                        label: this.$LANG.Get('fields.currency')
                    },
                    {
                        name: 'actions',
                        width: '200px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    number: '',
                    supplier_name: '',
                    supplier_vat_id: '',
                    short_description: '',
                    date_of_issue_from: null,
                    date_of_issue_to: null
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'date_of_issue',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            tableActions: [
                {
                    label: this.$LANG.Get('tooltips.downloadVisualization'),
                    action: (item) => {
                        this.downloadVisualizationClick(item.id);
                    },
                    visible: (item) => {
                        return item.e_invoice_id != null && item.e_invoice_id != '';
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.downloadXml'),
                    action: (item) => {
                        this.downloadXmlClick(item.id);
                    },
                    visible: (item) => {
                        return item.e_invoice_id != null && item.e_invoice_id != '';
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.downloadFile'),
                    action: (item) => {
                        this.downloadClick(item);
                    },
                    visible: (item) => {
                        return item.file_upload && item.file_upload.id !== 0 && item.file_upload.name !== '';
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.delete'),
                    action: (item) => {
                        this.deleteClick(item);
                    },
                    visible: (item) => {
                        return item.e_invoice_id == null || item.e_invoice_id == '';
                    }
                },
            ],
            modal: {
                show: false,
                incomingInvoiceId: null
            },
            // No select filters here, so nothing needs a label captured; kept so the shared
            // clearFilter can look a name up without a special case.
            filterLabels: {},
            crossTabHandle: null
        }
    },
    computed: {
        // Entries whose value is empty are dropped by NevsTableFilters, so every filter can be listed
        // here and the panel picks the active ones.
        filterSummary() {
            let filters = this.tableData.filters;
            return [
                {
                    name: 'number',
                    label: this.$LANG.Get('fields.number'),
                    value: filters.number
                },
                {
                    name: 'supplier_name',
                    label: this.$LANG.Get('fields.supplierName'),
                    value: filters.supplier_name
                },
                {
                    name: 'supplier_vat_id',
                    label: this.$LANG.Get('fields.supplierVatId'),
                    value: filters.supplier_vat_id
                },
                {
                    name: 'short_description',
                    label: this.$LANG.Get('fields.shortDescription'),
                    value: filters.short_description
                },
                {
                    name: 'date_of_issue_from',
                    label: this.$LANG.Get('fields.date_of_issue_from'),
                    value: filters.date_of_issue_from === null ? '' : this.$HELPERS.FormatDate(filters.date_of_issue_from)
                },
                {
                    name: 'date_of_issue_to',
                    label: this.$LANG.Get('fields.date_of_issue_to'),
                    value: filters.date_of_issue_to === null ? '' : this.$HELPERS.FormatDate(filters.date_of_issue_to)
                }
            ];
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        downloadVisualizationClick(id) {
            window.open(this.$store.state.settings.API_BASE + 'incoming-invoices/download-visualization/' + id);
        },
        downloadXmlClick(id) {
            window.open(this.$store.state.settings.API_BASE + 'incoming-invoices/download-xml/' + id);
        },
        downloadClick(item) {
            if (item.file_upload && item.file_upload.link) {
                window.open(item.file_upload.link);
            }
        },
        deleteClick(incomingInvoice) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.incomingInvoiceDeletionQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('delete', 'incoming-invoices/' + incomingInvoice.id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-incoming-invoices', {});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        // The value each filter has when it is not restricting anything.
        emptyFilters() {
            return {
                number: '',
                supplier_name: '',
                supplier_vat_id: '',
                short_description: '',
                date_of_issue_from: null,
                date_of_issue_to: null
            };
        },
        clearFilter(entry) {
            this.tableData.filters[entry.name] = this.emptyFilters()[entry.name];
            if (this.filterLabels[entry.name] !== undefined) {
                this.filterLabels[entry.name] = '';
            }
        },
        // Expanding the panel makes it taller, so the table gets whatever height is left over.
        filtersToggled() {
            this.$nextTick(() => {
                this.resolveWindowResize();
            });
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'incoming-invoices/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        openClick(id) {
            this.modal.incomingInvoiceId = id;
            this.$nextTick(() => {
                this.modal.show = true;
            });
        },
        addClick() {
            this.modal.incomingInvoiceId = null;
            this.$nextTick(() => {
                this.modal.show = true;
            });
        },
        modalDone(success) {
            this.modal.show = false;
            this.modal.incomingInvoiceId = null;
            if (success) {
                this.$CROSS_TAB_BUS.TriggerEvent('reload-incoming-invoices', {});
            }
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'incoming-invoices', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            let offset = 205;
            //the filter panel shares the button row, so only its expanded fields add height above the table
            if (this.$refs.filterPanel) {
                offset += this.$refs.filterPanel.fieldsHeight();
            }
            this.tableData.height = window.innerHeight - offset + 'px';
        }
    },
    mounted() {

        this.$store.commit('selectMenu', 'finance');
        this.$store.commit('selectSubMenu', 'incomingInvoices');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.incomingInvoices'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        if (this.$store.state.user.client.e_invoices_token != '') {
            this.$API.APICall('get', 'incoming-invoices/fetch', {}, (data, success) => {
                if (success && vm.tableData.lastRequest != null) {
                    vm.reloadTable(vm.tableData.lastRequest);
                }
            }, false);
        }
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-incoming-invoices', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped>
:deep(.nevs-table-header td) {
    padding-bottom: 10px !important;
}
</style>
